const initToggleChips = (node = document) => {
  const containers = node.querySelectorAll('[data-toggle-chip]');
  [...containers].forEach((container) => {
    const input = container.querySelector('[data-toggle-chip-input]');
    const chips = container.querySelectorAll('[data-toggle-chip-item]');
    const removeActiveChip = () => {
      [...chips].forEach((chip) => chip.classList.remove('-active'));
      const apartmentsChip = container.querySelector('[data-apartments-chip]');
      if (apartmentsChip) apartmentsChip.classList.remove('-active');
      const townhouseChip = container.querySelector('[data-townhouse-chip]');
      if (townhouseChip) townhouseChip.classList.remove('-active');
    };
    [...chips].forEach((chip) =>
      chip.addEventListener('click', (e) => {
        e.preventDefault();

        if (chip.classList.contains('-active')) return;

        removeActiveChip();
        input.value = chip.dataset.toggleChipId;
        const changeEvent = new Event('change');
        input.dispatchEvent(changeEvent);
        chip.classList.add('-active');
      }),
    );
  });
};
export { initToggleChips };
